import { render, staticRenderFns } from "./AddMoreItemToShowDialog.vue?vue&type=template&id=4194869e"
import script from "./AddMoreItemToShowDialog.vue?vue&type=script&lang=js"
export * from "./AddMoreItemToShowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports